import React, { useEffect, useState } from 'react'
import './App.css'
import './Zoom.css'
import { Redirect } from 'react-router-dom'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { IoIosArrowBack } from 'react-icons/io'
import {
  IoTicketOutline,
  IoCalendarOutline,
  IoTimeOutline,
  IoLocationOutline,
  IoInformationCircleOutline,
} from 'react-icons/io5'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import Header from './layouts/Header'
import { API_URL } from './config'

var QRCode = require('qrcode.react')

const Zoom = () => {
  const history = useHistory()
  const location = useLocation()
  const {
    transactiondate,
    venue,
    eventtime,
    eventday,
    yearcreated,
    theme,
    admissions,
    totalcost,
    ticketnumber,
    eventid,
    refund_status,
    eventname,
  } = location.state

  const [qrPayload, setQrPayload] = useState('')
  const [loading, setLoading] = useState(true)

  const customername = localStorage.getItem('customername')
  const customerid = localStorage.getItem('customerid')
  document.title = customername
  const baseURL = `${API_URL}/apps/kscanner/webservices.php`
  useEffect(() => {
    Axios.get(
      baseURL +
        '?query=ZOOM-IN-TICKET&customerid=' +
        customerid +
        '&eventid=' +
        eventid +
        '&ticket_number=' +
        ticketnumber,
      {
        withCredentials: true,
      },
    )
      .then((response) => {
        setQrPayload(response.data.qr_payload ?? '')
        setTimeout(() => {
          setLoading(false)
        }, 1000)
      })
      .catch((error) => console.log(error))
  }, [])

  if (localStorage.getItem('customername') === null) {
    return <Redirect to="/login" />
  }

  const isVoid =
    refund_status === 'Pending' || refund_status === 'Under_review' || refund_status === 'Approved'

  return (
    <div className="view">
      <Header />

      <main className="zm-page" style={{ marginTop: 'var(--header-h)' }}>
        <div className="zm-container">
          <div className="zm-top">
            <button type="button" className="zm-back" onClick={() => history.goBack()}>
              <IoIosArrowBack size={18} />
              <span>Back</span>
            </button>

            <span className="zm-chip">
              <IoTicketOutline size={14} />
              {ticketnumber}
            </span>
          </div>

          {loading ? (
            <section className="zm-card zm-card--loading">
              <ClipLoader size={25} color="grey" />
            </section>
          ) : (
            <section className="zm-card">
              <div className="zm-head">
                {refund_status === 'Pending' ? (
                  <div className="zm-note zm-note--info">
                    <IoInformationCircleOutline size={18} />
                    <span>Refund request submitted. Awaiting review.</span>
                  </div>
                ) : refund_status === 'Under_review' ? (
                  <div className="zm-note zm-note--info">
                    <IoInformationCircleOutline size={18} />
                    <span>
                      Refund request under review. We'll notify you once a decision is made.
                    </span>
                  </div>
                ) : refund_status === 'Approved' ? (
                  <div className="zm-note zm-note--warn">
                    <IoInformationCircleOutline size={18} />
                    <span>This ticket has been refunded and is no longer valid.</span>
                  </div>
                ) : (
                  <h1 className="zm-title">
                    Show this Karamale QR code at the entrance to unlock the moment.
                  </h1>
                )}
              </div>

              <div className="zm-body">
                {qrPayload === '' ? (
                  <div className="zm-invalid">🚫 This QR code is invalid</div>
                ) : (
                  ''
                )}

                {refund_status === 'Under_review' || refund_status === 'Pending' ? (
                  <div className="zm-status">Ticket temporarily disabled</div>
                ) : refund_status === 'Approved' ? (
                  <div className="zm-status">This ticket is no longer valid</div>
                ) : (
                  ''
                )}

                <div className={`zm-qr ${isVoid ? 'zm-qr--void' : ''}`}>
                  <QRCode
                    value={qrPayload}
                    logoSize={30}
                    size={250}
                    fgColor={isVoid ? '#dcdcdc' : '#000'}
                    bgColor="#fff"
                  />
                </div>
              </div>

              {(eventname || eventday || eventtime || venue) && (
                <div className="zm-event">
                  {eventname && <div className="zm-event__name">{eventname}</div>}

                  <div className="zm-event__meta">
                    {eventday && (
                      <span>
                        <IoCalendarOutline /> {eventday}
                      </span>
                    )}
                    {eventtime && (
                      <span>
                        <IoTimeOutline /> {eventtime}
                      </span>
                    )}
                    {venue && (
                      <span>
                        <IoLocationOutline /> {venue}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </section>
          )}
        </div>
      </main>
    </div>
  )
}

export default Zoom
